import { Directive, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[langText]'
})
export class LangTextDirective implements OnInit, OnDestroy {

  @Input() langTextEn: string = '';
  @Input() langTextHi: string = '';

  private sub!: Subscription;

  constructor(
    private el: ElementRef,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.sub = this.languageService.language$
      .subscribe(lang => {
        this.el.nativeElement.textContent =
          lang === 'hi' ? this.langTextHi : this.langTextEn;
      });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
